const courses = [
  {
    code: 'ISO 9001',
    title: '품질경영시스템 심사원(보) 과정 (교육비 350,000원, 부가세별도)',
    duration: '16시간',
    level: '심사원(보)'
  },
  {
    code: 'ISO 14001',
    title: '환경경영시스템 심사원(보) 과정 (교육비 350,000원, 부가세별도)',
    duration: '16시간',
    level: '심사원(보)'
  },
  {
    code: 'ISO 45001',
    title: '안전보건경영시스템 심사원(보) 과정 (교육비 350,000원, 부가세별도)',
    duration: '16시간',
    level: '심사원(보)'
  },
  {
    code: 'ISO 27001',
    title: '정보보안경영시스템 심사원(보) 과정 (교육비 500,000원, 부가세별도)',
    duration: '16시간',
    level: '심사원(보)'
  },
  {
    code: 'ISO 42001',
    title: 'AI경영시스템 심사원(보) 과정 (교육비 500,000원, 부가세별도)',
    duration: '16시간',
    level: '심사원(보)'
  },
  {
    code: 'ISO 13485',
    title: '의료기기 품질경영시스템 심사원(보) 과정 (교육비 500,000원, 부가세별도)',
    duration: '16시간',
    level: '심사원(보)'
  }
];

const benefits = [
  {
    icon: 'ri-file-text-line',
    title: '국내 유명 인증원 정식 등록',
    description: '교육 수료 후 소정의 시험 합격 시 국내 유명 인증원에 정식 심사원(보)로 등록됩니다.'
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: '전문직 커리어 및 고수익',
    description: '심사원(보) 활동을 통한 전문직 커리어 구축과 고수익 창출 기회를 제공합니다.'
  },
  {
    icon: 'ri-user-star-line',
    title: '현직 심사원(보)의 실무 노하우',
    description: '이론뿐만 아니라 현직 심사원(보)의 실무 중심 노하우를 직접 전수받습니다.'
  }
];

export default function ISOEducation() {
  return (
    <section id="iso-education" className="py-16 md:py-24 px-4 md:px-6 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-16">
          <p className="text-teal-600 text-xs md:text-sm font-semibold uppercase tracking-wider mb-2 md:mb-3">
            ISO Education
          </p>
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-gray-900 mb-4 md:mb-6 px-2">
            ISO심사원(보) 교육
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-2">
            <span className="hidden md:block">인증 심사원(보) 양성을 통한 제2의 커리어 설계</span>
            <span className="md:hidden">심사원(보) 양성으로 제2의 커리어 설계</span>
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 mb-10 md:mb-16">
          <div>
            <div 
              className="rounded-2xl overflow-hidden shadow-xl mb-6 md:mb-8"
              style={{ width: '100%', height: '300px' }}
            >
              <img
                src="https://public.readdy.ai/ai/img_res/b51b9fc70cc9e70ad406a01eacdc35e2.jpg"
                alt="ISO 교육"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 md:mb-6">운영 과정</h3>
            <div className="space-y-3 md:space-y-4">
              {courses.map((course, index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg p-4 md:p-6 shadow-sm border border-gray-200 hover:border-teal-300 transition-colors"
                >
                  <div className="flex items-center justify-between mb-2">
                    <span className="px-2.5 py-0.5 md:px-3 md:py-1 bg-teal-600 text-white text-xs md:text-sm font-bold rounded-md">
                      {course.code}
                    </span>
                    <span className="text-xs md:text-sm text-gray-500">{course.duration}</span>
                  </div>
                  <h4 className="text-base md:text-lg font-bold text-gray-900 mb-1 leading-tight">{course.title}</h4>
                  <p className="text-xs md:text-sm text-teal-600 font-semibold">{course.level}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 md:mb-6">특장점</h3>
            <div className="space-y-4 md:space-y-6 mb-6 md:mb-8">
              {benefits.map((benefit, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl p-5 md:p-6 shadow-sm border border-gray-200"
                >
                  <div className="flex items-start gap-3 md:gap-4">
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className={`${benefit.icon} text-xl md:text-2xl text-teal-600`}></i>
                    </div>
                    <div>
                      <h4 className="text-base md:text-lg font-bold text-gray-900 mb-1 md:mb-2 leading-tight">{benefit.title}</h4>
                      <p className="text-gray-600 leading-relaxed text-sm md:text-base">{benefit.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-xl p-6 md:p-8 text-white">
              <h4 className="text-xl md:text-2xl font-bold mb-4 md:mb-4">교육 프로세스</h4>
              <div className="space-y-3 md:space-y-4">
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-8 h-8 md:w-10 md:h-10 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="font-bold text-sm md:text-base">1</span>
                  </div>
                  <div>
                    <strong className="text-sm md:text-base">교육 신청 및 등록</strong>
                    <p className="text-white/90 text-xs md:text-sm leading-relaxed">원하시는 과정을 선택하고 신청합니다</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-8 h-8 md:w-10 md:h-10 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="font-bold text-sm md:text-base">2</span>
                  </div>
                  <div>
                    <strong className="text-sm md:text-base">16시간 집중 교육</strong>
                    <p className="text-white/90 text-xs md:text-sm leading-relaxed">이론과 실무를 겸비한 전문 교육</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-8 h-8 md:w-10 md:h-10 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="font-bold text-sm md:text-base">3</span>
                  </div>
                  <div>
                    <strong className="text-sm md:text-base">시험 및 자격 취득</strong>
                    <p className="text-white/90 text-xs md:text-sm leading-relaxed">수료 후 시험 합격 시 심사원(보) 등록</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-8 h-8 md:w-10 md:h-10 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="font-bold text-sm md:text-base">4</span>
                  </div>
                  <div>
                    <strong className="text-sm md:text-base">심사원(보) 활동 시작</strong>
                    <p className="text-white/90 text-xs md:text-sm leading-relaxed">전문 심사원(보)으로 커리어 시작</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border border-gray-200 mt-6">
              <h4 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 md:mb-6">교육 커리큘럼</h4>
              <div className="space-y-4">
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-8 h-8 md:w-10 md:h-10 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-book-open-line text-lg md:text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h5 className="text-sm md:text-base font-bold text-gray-900 mb-1">표준 및 요구사항 분석</h5>
                    <p className="text-gray-600 text-xs md:text-sm leading-relaxed">해당 ISO 규격의 조항별 핵심 내용과 HLS 구조 완벽 이해</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-8 h-8 md:w-10 md:h-10 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-file-list-3-line text-lg md:text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h5 className="text-sm md:text-base font-bold text-gray-900 mb-1">심사 가이드라인 학습</h5>
                    <p className="text-gray-600 text-xs md:text-sm leading-relaxed">ISO 19011 기반의 심사 원칙, 절차 및 심사원 윤리 강령 습득</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-8 h-8 md:w-10 md:h-10 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-tools-line text-lg md:text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h5 className="text-sm md:text-base font-bold text-gray-900 mb-1">심사 실무 실습</h5>
                    <p className="text-gray-600 text-xs md:text-sm leading-relaxed">체크리스트 작성, 인터뷰 기법 및 객관적 증거 수집 방법론 실습</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-8 h-8 md:w-10 md:h-10 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-file-chart-line text-lg md:text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h5 className="text-sm md:text-base font-bold text-gray-900 mb-1">결과 보고 및 사후 관리</h5>
                    <p className="text-gray-600 text-xs md:text-sm leading-relaxed">부적합 보고서 작성, 시정 조치 확인 및 최종 보고 기법 정립</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-8 h-8 md:w-10 md:h-10 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-award-line text-lg md:text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h5 className="text-sm md:text-base font-bold text-gray-900 mb-1">자격 평가</h5>
                    <p className="text-gray-600 text-xs md:text-sm leading-relaxed">교육 이수 후 심사 역량을 검증하는 필기 시험 및 수행 평가 진행</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-cyan-50 to-teal-50 rounded-2xl p-6 md:p-10 border border-teal-100">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-6 text-center md:text-left">
            <div>
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-1 md:mb-2 leading-tight">
                제2의 커리어를 준비하세요
              </h3>
              <p className="text-gray-700 text-sm md:text-base leading-relaxed">
                ISO 심사원(보) 교육을 통해 전문가로 성장할 수 있는 기회를 잡으세요.
              </p>
            </div>
            <a
              href="#contact"
              className="w-full md:w-auto px-6 py-3 md:px-8 md:py-4 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-2 text-sm md:text-base"
            >
              교육 문의하기
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
